import { SigninForm } from '@/components/auth/signin-form'

export default function SignInPage() {
  return (
    <div className='flex min-h-screen w-full items-center justify-center bg-background'>
      <SigninForm />
    </div>
  )
}
